export default {
	/**
	 * Resolves an array of client objects from the API.
	 *
	 * @returns {Promise<array>}
	 */
	async all () {},

	/**
	 * Resolves a single client from the given ID.
	 *
	 * @param {int} id The client ID to retrieve
	 * @returns {Promise<object>}
	 */
	async find (id) {},

	/**
	 * Creates a new client.
	 *
	 * @param {string} name The client name
	 * @param {int} threshold The threshold devices will use for the "is_online" status.
	 * @param {string} thresholdUnit The unit for the threshold
	 * @param {array} connections An array of Translator Connection IDs
	 * @param {bool} isActive Flag that shows if the client is active.
	 * @returns {Promise<object>} The newly-created Client object.
	 */
	async store (name, threshold, thresholdUnit, connections, isActive) {},

	/**
	 * Creates a new client.
	 *
	 * @param {int} clientId The client ID to update
	 * @param {string} name The client name
	 * @param {int} threshold The threshold devices will use for the "is_online" status.
	 * @param {string} thresholdUnit The unit for the threshold
	 * @param {array} connections An array of Translator Connection IDs
	 * @param {bool} isActive Flag that shows if the client is active.
	 * @returns {Promise<object>} The newly updated Client object.
	 */
	async update (clientId, name, threshold, thresholdUnit, connections, isActive) {},

	/**
	 * Deletes the client with the given ID.
	 *
	 * @param {int} clientId The client ID to delete
	 * @returns {Promise}
	 */
	async delete (clientId) {},

	/**
	 * Retrieves an array of monitors from the given client ID.
	 *
	 * @param {int} clientId The client ID to query against
	 * @returns {Promise<array>}
	 */
	async getMonitors (clientId) {},

	/**
	 * Retrieves an array of monitor types from the given client ID.
	 *
	 * @param {int} clientId The client ID to query against
	 */
	async getMonitorTypes (clientId) {},

	/**
	 * Retrieves the given monitor type from the given client ID.
	 *
	 * @param {int} clientId The client ID to query against
	 * @param {string} monitorType The monitor type key
	 * @param {object} settings The settings to be sent with the query
	 */
	async getMonitorType (clientId, monitorType, settings) {},

	/**
	 * retrieves the notifications for a client
	 *
	 * @param clientId
	 * @returns {Promise<Array|Object|string>}
	 */
	async getNotifications (clientId) {}
};
